import React, { lazy, useState } from 'react';

const DocumentTutorialModal = lazy(() => import('./DocumentTutorialModal'));

export default function useDocumentTutorialModal() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const modal = () => {
    if (!isOpen) return null;
    return <DocumentTutorialModal closeModal={closeModal} />;
  };
  return {
    openModal,
    closeModal,
    modal,
  };
}
